import { Media, Product, Theme } from '@/payload-types';
import { clsx } from 'clsx';
import { MediaComponent } from '@/components/Media';
import { pseudoI18n } from '@/i18n/pseudoI18n';
import Button from '@/components/button';
import { PATHS } from "@/constants/paths";
import Link from "next/link";

interface IProductCardProps {
  product: Product;
  className?: string;
  theme?: Theme;
}

export default function ProductCard( props: IProductCardProps ) {
  const { product, className, theme } = props;
  const { images, productName, slug, productCode } = product;

  const heroImage = images?.[ 0 ];
  const productUrl = `${ PATHS.PRODUCTS }/${ slug }`;

  const { t } = pseudoI18n();

  return (
    <Link href={ productUrl } className={ clsx( 'h-full flex flex-col gap-3', className ) }>
      <MediaComponent
        resource={ { ...( ( heroImage as Media ) || {} ), height: 300, width: 450 } }
        imgClassName="object-contain h-36 m-auto"
      />
      <p className='line-clamp-3'>
        <strong className='font-medium'>{ productName }</strong>
      </p>
      <p className="mt-auto">
        <strong>SKU: </strong>
        <span>{ productCode }</span>
      </p>
      <Button
        type='button'
        style="primary-button--inverse"
        theme={ theme }
        className="w-full font-semibold text-center text-secondary"
      >
        { t( 'View detail' ) }
      </Button>
    </Link>
  );
}
